import { noop } from '@page/core/utils/function';
import { createContext } from 'react';

type SearchInputContextType = {
  handleAddTag: (tag: string) => void;
  handleRemoveTag: (tag: string) => void;
};

export const SearchInputContext = createContext<SearchInputContextType>({
  handleAddTag: noop,
  handleRemoveTag: noop,
});
